export default {
  init() {
    var initialState = true;
    $(window).scroll(function() {
        var offset = $(window).scrollTop();
        if (offset > 40) {
          if (initialState === true) {
            $('nav').addClass('scrolled');
            initialState = false;
          }
        } else {
          if (initialState === false) {
            $('nav').removeClass('scrolled');
            initialState = true;
          }
        }
    });
    $('.navbar-toggler').on('click', function() {
      $('nav').toggleClass('menu-expanded');
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
